import styled from "@emotion/styled";
import OpenInExplorerIcon from "../../../img/trade-history/OpenLink.svg?react";
import { TransactionDetail } from "types/history";
import { openTransactionInBlockExplorer } from "utils/txUtils";

interface OpenInExplorerCellProps {
  chainId: TransactionDetail["chain_id"];
  txHash: TransactionDetail["txHash"];
}

export const OpenInExplorerCell = ({ chainId, txHash }: OpenInExplorerCellProps) => {
  return (
    <Container onClick={() => openTransactionInBlockExplorer(chainId, txHash)}>
      <OpenInExplorerIcon />
    </Container>
  );
};

// Sub-components

export const Container = styled.div`
  height: 28px;
`;
